<ng-container *ngIf="model">
  <div
    class="badge"
    [class]="computedClass"
    [class.only-icon]="model.icon && !model.text"
    [style.background-color]="theme === 'light' ? model.backgroundColor?.lightTheme : model.backgroundColor?.darkTheme"
    [style.color]="theme === 'light' ? model.textColor?.lightTheme : model.textColor?.darkTheme"
    [style.border-color]="theme === 'light' ? model.border?.lightTheme : model.border?.darkTheme"
    [ngClass]="{ border: model.border }"
    [pTooltip]="model.tooltip"
    tooltipPosition="bottom"
    tooltipStyleClass="u-tooltip"
  >
    <u-icon *ngIf="model.icon" class="icon" [styles]="{ width: '16px' }" [model]="iconModel"></u-icon>
    <span class="text" [innerHtml]="model.text" [dragAndDrop]="model"></span>
  </div>

  <dropdown #dropdown *ngIf="hasDropdown" [model]="model.dropdown" (invoke)="sendCommand($event)"></dropdown>
</ng-container>
